/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getAssociatedCrmIdsRpc = {
  serviceName: 'com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc',
  rpcName: 'getAssociatedCrmIds',
  auth: 'app',
  fingerprint: 'qWn3S4sYSVve8Cy_ciROS6WxTDfmzflm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkAssociateFromCrmSearchRpc = {
  serviceName: 'com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc',
  rpcName: 'bulkAssociateFromCrmSearch',
  auth: 'app',
  fingerprint: 'x1MQD2eRiN6O0TPsNYW3laWxTDfmzflm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setAssociationsRpc = {
  serviceName: 'com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc',
  rpcName: 'setAssociations',
  auth: 'app',
  fingerprint: 'gh3unpokJzm4GuK-FjCNSKWxTDfmzflm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const associateWithCampaignsRpc = {
  serviceName: 'com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc',
  rpcName: 'associateWithCampaigns',
  auth: 'app',
  fingerprint: 'tCvf0SU6D7coVjq_zgdTjqWxTDfmzflm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const dissociateFromCampaignsRpc = {
  serviceName: 'com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc',
  rpcName: 'dissociateFromCampaigns',
  auth: 'app',
  fingerprint: 'tCvf0SU6D7eOUe2e_r4XmaWxTDfmzflm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAssociableObjectTypesRpc = {
  serviceName: 'com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc',
  rpcName: 'getAssociableObjectTypes',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAOb3jXBjE7gpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalAssociableObjectTypesRpc = {
  serviceName: 'com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc',
  rpcName: 'getPortalAssociableObjectTypes',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAOb3jXBjE7gqWxTDfmzflm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAssetMappingsRpc = {
  serviceName: 'com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc',
  rpcName: 'getAssetMappings',
  auth: 'app',
  fingerprint: '3qZTXdZWqn_dSbwvQzdcLqWxTDfmzflm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMetricTotalsRpc = {
  serviceName: 'com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc',
  rpcName: 'getMetricTotals',
  auth: 'app',
  fingerprint: '3qZTXdZWqn8CCoeQQ5y9M6WxTDfmzflm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSingleAssetMappingRpc = {
  serviceName: 'com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc',
  rpcName: 'getSingleAssetMapping',
  auth: 'app',
  fingerprint: 'Mv92SlsSKTJHjovz0XEiJqWxTDfmzflm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBatchAssetMappingRpc = {
  serviceName: 'com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc',
  rpcName: 'getBatchAssetMapping',
  auth: 'app',
  fingerprint: 'FqqW96oqLdjQOJz12H1KsqWxTDfmzflm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMetricTotalsWithFirstPageRpc = {
  serviceName: 'com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc',
  rpcName: 'getMetricTotalsWithFirstPage',
  auth: 'app',
  fingerprint: 'GXC_n9SPmyEzfmcGLv5A1aWxTDfmzflm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const isAssociationsLimitReachedRpc = {
  serviceName: 'com.hubspot.campaigns.association.rpc.CampaignsAssociationRpc',
  rpcName: 'isAssociationsLimitReached',
  auth: 'app',
  fingerprint: '4OtWRHkOFODjmTLxyTisqaWxTDfmzflm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};